// extracted by mini-css-extract-plugin
module.exports = {"search":"reviewSubmit_search__CG7PQ","icon":"reviewSubmit_icon__ODFWo","subtitle":"reviewSubmit_subtitle__j5xpu"};